import { JustRightHeightModal } from 'components/styled/scoped';
import { useCallback, useState } from 'react';
import { Form } from 'antd';
import { useTranslate } from '@tolgee/react';
import MultipleTimePicker from './MultipleTimePicker';
import { useLatest } from 'ahooks';

function resetValue(value?: MultiTimeSelect.EffectiveTime) {
  const newValue = Object.assign({}, value);
  if (newValue.repeatType === 'DAY') {
    newValue.yearRepeat = [];
    newValue.weekRepeat = [];
  }
  if (newValue.repeatType === 'WEEK') {
    newValue.yearRepeat = [];
    newValue.dayRepeat = [];
  }
  if (newValue.repeatType === 'YEAR') {
    newValue.weekRepeat = [];
    newValue.dayRepeat = [];
    newValue.dtRange = {
      startAt: '',
      endAt: '',
    };
  }

  return newValue;
}

const useMultiTimeSelect = (props?: {
  onSelect?: (value: MultiTimeSelect.EffectiveTime) => void;
}) => {
  const onSelectRef = useLatest(props?.onSelect);
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();
  const { t } = useTranslate();
  const open = useCallback(
    (value?: MultiTimeSelect.EffectiveTime) => {
      setVisible(true);
      form.setFieldsValue({
        effectiveTime: value,
      });
    },
    [form],
  );

  const cancel = useCallback(() => {
    form.resetFields();
    setVisible(false);
  }, [form]);

  const handleOk = useCallback(() => {
    form.validateFields().then((value) => {
      onSelectRef.current?.(resetValue(value.effectiveTime));
      cancel();
    });
  }, [form, onSelectRef, cancel]);

  const modal = visible && (
    <JustRightHeightModal
      visible={visible}
      onCancel={cancel}
      width={625}
      title={t('multiTimeSelect.编辑循环时间段')}
      maskClosable={false}
      onOk={handleOk}
      bodyStyle={{
        padding: '16px',
      }}
    >
      <div className="w-[524px]">
        <Form form={form} layout="vertical" validateTrigger={['onBlur', 'onFocus']}>
          <Form.Item label={`${t('multiTimeSelect.生效日期')}:`} name="effectiveTime">
            <MultipleTimePicker />
          </Form.Item>
        </Form>
      </div>
    </JustRightHeightModal>
  );

  return [open, modal] as const;
};

export default useMultiTimeSelect;
